"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
require("./progressBar.scss");
const ProgressBar = ({ containerClass, width, height, actualProgress, expectedProgress, bgColor = (0, HelperUtils_1.getCssVariableValue)('--n-400'), actualColor = (0, HelperUtils_1.getCssVariableValue)('--r-500'), expectedColor = (0, HelperUtils_1.getCssVariableValue)('--n-600'), useAnimation = true, dataCy = 'progress-bar', useActualColorHex = true }) => {
    const [refWidth, setRefWidth] = (0, react_1.useState)(0);
    const ref = (0, react_1.useRef)(null);
    const percentage = (num) => {
        return (num / 100) * (width || refWidth);
    };
    const widthExpected = expectedProgress ? percentage(expectedProgress) : 0;
    const widthActual = actualProgress ? percentage(actualProgress) : 0;
    (0, react_1.useEffect)(() => {
        var _a;
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            setRefWidth((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    return (react_1.default.createElement("div", { className: `${containerClass ? containerClass : ''}`, "data-cy": dataCy },
        react_1.default.createElement("div", { ref: ref, "data-cy": "progress-bar-background", className: "rounded-full overflow-hidden", style: {
                width: width ? `${width}px` : '100%',
                height: height ? `${height}px` : '100%',
                backgroundColor: `#${bgColor}`
            } },
            react_1.default.createElement("div", { "data-cy": "progress-bar-expected", className: `${useAnimation ? 'animation-progressbar' : ''} h-full`, style: {
                    '--to-width': `${widthExpected}px`,
                    width: `${widthExpected}px`,
                    backgroundColor: `#${expectedColor}`
                } },
                react_1.default.createElement("div", { "data-cy": "progress-bar-actual", className: `${useAnimation ? 'animation-progressbar' : ''} h-full`, style: {
                        '--to-width': `${widthActual}px`,
                        width: `${widthActual}px`,
                        backgroundColor: useActualColorHex
                            ? `#${actualColor}`
                            : actualColor
                    } })))));
};
exports.default = ProgressBar;
